<template>
  <div
    class="pt-3 h-full relative backdrop-blur-md text-[--tml-menu-text-color] bg-[--tml-menu-background-color]"
  >
    <div class="h-full overflow-y-auto overflow-x-hidden">
      <slot />
    </div>
    <div id="sidebar-overflow-container" class="absolute top-0 left-0 right-0"></div>
  </div>
</template>
